import axios from 'axios';

export const download = (url: string, fileName?: string): void => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || '';
    link.target = '_self';
    link.click();
    link.remove();
};

export const downloadBlob = (data: BlobPart, fileName: string): void => {
    const blob = new Blob([data], {
        type: 'application/octet-stream',
    });
    const url = window.URL.createObjectURL(blob);
    download(url, fileName);
    window.URL.revokeObjectURL(url);
};

export const fileDownload = async (url: string): Promise<void> => {
    const instance = axios.create();

    const res = await instance.get(url, {
        timeout: 400000,
        responseType: 'blob',
    });

    const contentDisposition = res.headers['content-disposition'];
    let fileName = 'unknown';
    if (contentDisposition) {
        const fileNameMatch = /filename\s?=\s?"?'?(.+)"?'?/.exec(contentDisposition);

        if (fileNameMatch && fileNameMatch.length === 2) {
            fileName = fileNameMatch[1].replace(/["']/g, '').trim();
        }
    }

    downloadBlob(res.data, fileName);
};
